import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import { appRoute } from 'app/railways/router/routes';

import { TRole } from '../../../core/role';

export const cols: TEntityGridColumn<TRole>[] = [
  {
    field: 'id',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: false,
    checkboxSelection: false,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TRole }) => {
      const path = appRoute.ROLES.DETAILS.buildPath({ roleId: data.id });

      return <Link to={path}>{data.id}</Link>;
    },
  },
  {
    field: 'title',
    headerName: 'Название',
    sortable: false,
    colId: 'number',
    comparator: () => 0,
  },
  {
    headerName: '',
    sortable: false,
    colId: 'details',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TRole }) => {
      const path = appRoute.ROLES.DETAILS.buildPath({ roleId: data.id });

      return <Link to={path}>Подробнее</Link>;
    },
  },
];
